/*
 * Esprit Salopette — section « Ils portent Esprit Salopette » (sections/es-reviews.liquid).
 * - Carrousel principal (commandes de section) : change de client.
 * - Carrousel interne de chaque carte (commandes posées sur la photo) : change de vue du même client.
 *   Glissement tactile natif (scroll-snap + overscroll-behavior: contain, pour ne pas entraîner le carrousel
 *   principal), flèches, touches ← → quand le focus est sur la photo, compteur « 1/3 ».
 *   Aucune rotation automatique. Les vues secondaires ne se chargent qu'à l'approche.
 */
(() => {
  const smooth = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

  const loadView = (view) => {
    const img = view && view.querySelector('img[data-es-src]');
    if (!img) return;
    img.src = img.dataset.esSrc;
    img.removeAttribute('data-es-src');
  };

  function initCard(card) {
    const views = card.querySelector('[data-es-rev-views]');
    const items = views ? Array.from(views.querySelectorAll('[data-es-view]')) : [];
    if (items.length < 2) return;

    const prev = card.querySelector('[data-es-view-prev]');
    const next = card.querySelector('[data-es-view-next]');
    const current = card.querySelector('[data-es-view-current]');
    let index = 0;

    const set = (i, preload = true) => {
      index = i;
      if (current) current.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === items.length - 1;
      items.forEach((view, k) => {
        const button = view.querySelector('button');
        if (button) button.tabIndex = k === i ? 0 : -1;
        view.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      loadView(items[i]);
      if (preload) loadView(items[i + 1]);
    };

    const go = (i) => {
      const target = Math.max(0, Math.min(items.length - 1, i));
      views.scrollTo({ left: target * views.clientWidth, behavior: smooth() });
      set(target);
    };

    prev && prev.addEventListener('click', (event) => { event.stopPropagation(); go(index - 1); });
    next && next.addEventListener('click', (event) => { event.stopPropagation(); go(index + 1); });

    let frame = null;
    views.addEventListener('scroll', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const i = Math.round(views.scrollLeft / views.clientWidth);
        if (i !== index && items[i]) set(i);
      });
    }, { passive: true });

    /* Préchargement de la 2e vue dès que l'utilisateur s'intéresse à la carte. */
    const warm = () => loadView(items[1]);
    card.addEventListener('pointerenter', warm, { once: true });
    views.addEventListener('touchstart', warm, { once: true, passive: true });
    card.addEventListener('focusin', warm, { once: true });

    card.querySelector('[data-es-rev-media]').addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      event.stopPropagation();
      go(index + (event.key === 'ArrowRight' ? 1 : -1));
      const button = items[index].querySelector('button');
      if (button) button.focus({ preventScroll: true });
    });

    set(0, false);
  }

  function initSection(root) {
    if (root.dataset.esRevReady) return;
    root.dataset.esRevReady = '1';

    root.querySelectorAll('[data-es-rev-card]').forEach(initCard);

    const track = root.querySelector('[data-es-rev-track]');
    const prev = root.querySelector('[data-es-rev-prev]');
    const next = root.querySelector('[data-es-rev-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const card = track.querySelector('[data-es-rev-card]');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      root.classList.toggle('es-rev--static', max <= 0);
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: smooth() }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: smooth() }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  const init = () => document.querySelectorAll('[data-es-rev]').forEach(initSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
